import { VirtualMeetingType } from "@teaming/common-enums";

const articleLink = "http://help.teaming.com/en/articles/7838470-automatically-generate-notes-from-a-meeting-recording";

export default {
	stage1Text: `Hi! I’m Opre Assistant, and I can take notes for you! Simply add the videoconference link for your meeting to get started. Not meeting virtually? No problem; I can <a href="${ articleLink }" target="_blank" title="Automatically Generate Notes from a Meeting Recording">create notes from a recording</a> after your meeting.`,
	stage2Text: "Paste your meeting link in the field below and click ‘Save,’ so I know where to go.",
	stage2Placeholder: "e.g. ‘https://zoom.us/x/1234567890’",
	stage2Hint: "Right now I can only join Zoom, Google Meet, Microsoft Teams, or Webex meetings.",
	stage3Text: "Now click ‘Go’ to add me to your meeting and I’ll take notes for you!",

	takeNotesButton: "Take notes for me",
	notNowButton: "Not now",
	saveButton: "Save",
	editLinkButton: "Edit link",
	goButton: "Go!",

	//
	// bot alerts
	//
	// bot: REQUESTED_RETRY *
	botRetryAlert: "I’ve experienced a delay joining your {service} meeting, and is retrying.",
	// bot: QUEUED joining_call
	botIsJoiningAlert: "I’m joining your meeting now.",
	// bot: QUEUED teaming_scheduled
	botIsScheduledAlert: "I’ll automatically join your meeting at the scheduled time to transcribe and summarize your notes. If you’re ready to meet before that, click ‘start now.’",
	// bot: QUEUED in_waiting_room
	botIsWaitingAlert: "I’m stuck in the “waiting room” of your meeting. Please have the host admit “Opre Meeting Assistant”.",
	// bot: QUEUED in_call_not_recording
	botIsNotRecordingAlert: "I’ve joined the meeting, but am not yet recording. I may still be setting up, do not have recording permission, or the recording was paused.",
	// bot: QUEUED in_call_recording
	botIsRecordingAlert: "I’ve joined the meeting, and am recording and transcribing notes. You may close or navigate away from this page, and I’ll notify you when your summary is ready.",
	// bot: QUEUED call_ended
	botCallEndedAlert: "I’ve left the meeting, and am summarizing your meeting notes for you. You may close or navigate away from this page, and I’ll notify you when the summary is ready.",
	// bot: FAILED fatal
	botFatalAlert: "Uh oh, I’ve encountered an error that prevented me from joining your meeting. Please verify or edit the meeting link below to try again.",

	//
	// upload alerts
	//
	uploadTranscribingAlert: "Transcription and summarization in progress. You may navigate away from this page, and we will notify you when the summary is ready.",
	uploadErrorAlert: "There was an error processing your recording for transcription. Please re-upload your file and try again.",

	cancelButton: "Cancel",
	startButton: "Start now",

	[ `${ VirtualMeetingType.ZOOM }label` ]: "Zoom",
	[ `${ VirtualMeetingType.MICROSOFT_TEAMS }label` ]: "Microsoft Teams",
	[ `${ VirtualMeetingType.GOOGLE_MEET }label` ]: "Google Meet",
};
